import Nav from "./nav"
import Countdown from "./countdown"
import ProjectFilter from "./project-filter"
import FestivalDayFilter from "./festival-day-filter"
import NewsSlider from "./news_slider"
import Swiper from "./swiper"

document.addEventListener("DOMContentLoaded", function () {
    Nav(jQuery)
    Countdown(jQuery)
    ProjectFilter(jQuery)
    FestivalDayFilter(jQuery)
    NewsSlider(jQuery)
    Swiper(jQuery)
})
